export const resources = {
  resourcesFolderInfoText: 'File',
  resourcesItemInfoLastUpdText: 'Ultima modifica',
  resourcesItemInfoUploadedText: 'Caricato',
  resourcesSearchInputText: 'Cerca',
  resourcesUserActionSheetOptionTitle: 'Copia link',
  resourcesActionCopiedAlertText: 'Link copiato!',
  resourcesOwnersCurtainEditOptionText: 'Modifica titolo',
  resourcesOwnersCurtainDeleteOptionText: 'Elimina',
  resourcesOwnerCurtainHideOptionText: 'Nascondi (Inattivo)',
  resourcesEditPopupTitle: 'Modifica titolo',
  resourcesEditPopupResetButtonTitle: 'Resetta',
  resourcesEditPopupApplyButtonTitle: 'Applica',
  resourcesItemEditedAlertText: 'Elemento aggiornato con successo!',
  resourcesHidePopupTitle: 'Nascondi',
  resourcesHidePopupText: 'Nascondere questo elemento?',
  resourcesHidePopupCancelButtonTitle: 'Annulla',
  resourcesHidePopupConfirmButtonTitle: 'Conferma',
  resourcesDeletePopupTitle: 'Elimina',
  resourcesDeletePopupText: 'Eliminare questo elemento?',
  resourcesDeletePopupCancelButtonTitle: 'Annulla',
  resourcesDeletePopupConfirmButtonTitle: 'Conferma',
  resourcesItemDeletedAlertText: 'Elemento eliminato con successo!',
  resourceDetailsLinkText: 'Si tratta di un URL esterno e verrà aperto in una nuova finestra. Aprire?',
  resourceDetailsLinkOpenButtonTitle: 'Apri',
  resourceDetailsLinkOpenAgainButtonTitle: 'Apri di nuovo',
  resourceDetailsLinkCopyURLButtonTitle: 'Copia URL di destinazione',
  resourceDetailsLinkCopiedURLAlertText: 'URL copiato!',
  resurceDetailsLinkCurtainOptionCopyText: 'Copia link',
  resourceDetailsFileInfoLastUpdText: 'Ultima modifica',
  resourceDetailsFileInfoUploadText: 'Caricato',
  resourceDetailsFileSaveButtonTitle: 'Apri',
  resourceDetailsFileCopyButtonTitle: 'Copia link',
  resourcesOwnersCurtainCopyOptionText: 'Copia link',
  resourceDetailsFileLoadingText: 'Caricamento...',
  resourceDetailsImageCurtainCopyOptionText: 'Copia link',
  resourceDetailsImageCurtainDownloadOptionText: 'Scarica',
  resourceFolder: 'Cartella',
  resourceAdded: 'Aggiunto'
}
